import React, { useState } from 'react'
import { Button, Pane, Text } from 'evergreen-ui'
import { MdPayments } from 'react-icons/md'
import { AllowPay } from '../../../Components/AllowPermission'
import PaymentDialog from '../../../Components/PaymentDialog'


const DetailComment = ({ DataRegister }) => {
    console.log("DataRegister DetailComment: ", DataRegister);
    const validCodes = [
        "1101",
        "1102",
        "1103",
        "1106",
        "1110",
        "1207",
        "1208",
        "1301",
        "1302",
        "1304",
        "1310",
    ];
    return (
        <>
            <>

                {
                    (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
                    (
                        <>
                            {
                    (
                        DataRegister[0].ROB_ID === "177" || DataRegister[0].ROB_ID === "178") ?
                        validCodes.includes(DataRegister[0].Major_MAJOR_ID) ?
                            (
                                <Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                    </Text>
                                </Pane>
                            )
                            :


                            null

                        :
                        (
                            <>
                                <Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ
                                    </Text>
                                </Pane>
                            </>
                        )
                }
                        </>
                    )
                    :
                    (
                        <>
                        {
                            (DataRegister[0].REGISTER_TYPE_ID === "4" || DataRegister[0].REGISTER_TYPE_ID === "7") ? (<Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        หมายเหตุ : ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 30 มกราคม 2569
                                    </Text>
                                </Pane>)    : null
                        }
                        {
                            (DataRegister[0].REGISTER_TYPE_ID === "2" || DataRegister[0].REGISTER_TYPE_ID === "3") ? (<Pane
                                    color="#fff"
                                    backgroundColor="#ff0000ff"
                                    height="100%"
                                    paddingY={4}
                                    paddingX={5}
                                    fontSize={14}
                                    fontFamily=""
                                    margin={0}
                                    fontWeight={700}
                                    display="flex"
                                    flexDirection="column"
                                    marginTop={5}
                                >
                                    <Text fontWeight={600} fontSize={14} color="#ffffff">
                                        หมายเหตุ : ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 21 เมษายน 2569
                                    </Text>
                                </Pane>)    : null
                        }
                        </>
                    )
                }

            </>

        </>
    )
}

export default DetailComment